import React, { Component } from 'react';
import API from '../../utils/API';
import SaveBar from './components/SaveBar';

const DEFAULT = {
	decisionFactors: '',
	keyConsiderations: '',
	eventHistory: '',
	reservationNotes: ''
};

class KeyConsiderations extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: { ...DEFAULT, ...(props.request?.keyConsiderations || {}) },
			editing: false,
			saving: false
		};
	}

	update = (field, value) => {
		this.setState((s) => ({ data: { ...s.data, [field]: value }, editing: true }));
	};

	save = async () => {
		this.setState({ saving: true });
		try {
			await API().patch(
				`Organizations/${this.props.orgId}/proposal-requests/${this.props.requestId}`,
				{ keyConsiderations: this.state.data }
			);
			this.setState({ editing: false, saving: false });
			this.props.refreshSectionCounts && this.props.refreshSectionCounts();
		} catch (e) {
			console.error('Error saving key considerations:', e);
			this.setState({ saving: false });
		}
	};

	cancel = () => {
		this.setState({
			data: { ...DEFAULT, ...(this.props.request?.keyConsiderations || {}) },
			editing: false
		});
	};

	render() {
		const { data, editing, saving } = this.state;
		const { request } = this.props;

		return (
			<>
				<div className="pr-field-group">
					<label className="pr-field-label">Decision Factors</label>
					<p className="pr-field-sublabel">
						What will influence the final hotel/venue selection? (price, location, brand, airport proximity…)
					</p>
					<textarea
						className="pr-textarea"
						rows={4}
						value={data.decisionFactors || ''}
						onChange={(e) => this.update('decisionFactors', e.target.value)}
						placeholder="e.g. Price is top priority, followed by location and brand loyalty."
					/>
				</div>


				<h2 className="pr-subsection-title">History &amp; Reservations</h2>

				<div className="pr-field-group">
					<label className="pr-field-label">Event History</label>
					<p className="pr-field-sublabel">Previous venues, years hosted, attendance trends.</p>
					<textarea
						className="pr-textarea"
						rows={4}
						value={data.eventHistory || ''}
						onChange={(e) => this.update('eventHistory', e.target.value)}
						placeholder="Held at Marriott Marquis in 2024 with 420 attendees…"
					/>
				</div>

				<div className="pr-field-group">
					<label className="pr-field-label">Reservations / Booking Notes / Payment Details</label>
					<p className="pr-field-sublabel">Cut-off dates, booking codes, housing bureau details, payment information.</p>
					<textarea
						className="pr-textarea"
						rows={4}
						value={data.reservationNotes || ''}
						onChange={(e) => this.update('reservationNotes', e.target.value)}
						placeholder="Reservations cut-off 3 weeks prior, housing via Passkey, payment details…"
					/>
				</div>

				<SaveBar
					editing={editing}
					saving={saving}
					onSave={this.save}
					onCancel={this.cancel}
					updatedAt={request?.updatedAt}
				/>
			</>
		);
	}
}

export default KeyConsiderations;
